import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {handleError} from "../shared/util/error-util";
import {Observable} from "rxjs";
import {MemoriaCalculo} from "./memoria-calculo";

@Injectable({
  providedIn: 'root'
})
export class MemoriaCalculoService {

  readonly url = "/internal/v1/memorias-calculo/";

  constructor(private readonly httpclient: HttpClient) {
  }

  search(idResultadoExecucao: number): Observable<MemoriaCalculo> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params = new HttpParams();
    params = params.append("resultadoExecucao", String(idResultadoExecucao));

    return this.httpclient.get<MemoriaCalculo>(this.url, {headers, params}).pipe(catchError(handleError));
  }

  getPDFexportData(memoria: MemoriaCalculo): Observable<HttpResponse<Blob>> {
    return this.getExportDataFrom(this.url.concat(memoria.id.toString()).concat("/export/pdf"));
  }

  getXLSXexportData(memoria: MemoriaCalculo): Observable<HttpResponse<Blob>> {
    return this.getExportDataFrom(this.url.concat(memoria.id.toString()).concat("/export/xlsx"));
  }

  getExportDataFrom(path: string): Observable<HttpResponse<Blob>> {
    const params = new HttpParams();
    return this.httpclient.get(path, {
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }
}
